// extracted by mini-css-extract-plugin
module.exports = {"table":"InfoTable_table__VDYQe","header":"InfoTable_header__N0CNN","shadedCell":"InfoTable_shadedCell__tofFE"};